// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Views/HomePage';
import ExpertOnboarding from './components/onboarding/ExpertOnboarding';
import ExpertsList from './components/ExpertsList';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/browse-experts" element={<ExpertsList activeTopic="trending" />} />
          <Route path="/become-expert" element={<ExpertOnboarding />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;